/* eslint-disable sort-keys */
import { Environment } from '../../environment/environment';

type PreloaderPercentsLayout = {
    initialPercent: number,
    compilingEndPercent: number,
    clientLoadingStart: number,
    clientLoadingEnd: number
}

export const PRELOADER_PERCENTS_REAL: PreloaderPercentsLayout = {
    initialPercent: 0,
    compilingEndPercent: 20,
    clientLoadingStart: 20,
    clientLoadingEnd: 100
};

export const PRELOADER_PERCENTS_PROD: PreloaderPercentsLayout = {
    initialPercent: 56,
    compilingEndPercent: 66,
    clientLoadingStart: 66,
    clientLoadingEnd: 100
};

export const PRELOADER_PERCENTS_COMPILE_ONLY_PROD: PreloaderPercentsLayout = {
    initialPercent: 0,
    compilingEndPercent: 100,
    clientLoadingStart: 100,
    clientLoadingEnd: 100
};

export const COMPATIBILITY_CHECK_FAILED_PERCENTS = -2;

export function getPreloaderPercentsLayout(): PreloaderPercentsLayout {
    if (!Environment.isProduction()) {
        return PRELOADER_PERCENTS_REAL;
    }

    return PRELOADER_PERCENTS_PROD;
}
